let version = 0;
const listeners = new Set<() => void>();

export function subscribeAvatarCacheBusters(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getAvatarCacheBusterSnapshot(): number {
  return version;
}

export function notifyAvatarCacheBustersChanged(): void {
  version += 1;
  listeners.forEach((listener) => {
    listener();
  });
}
